import { render } from "./WebserverSubComponent.vue?vue&type=template&id=4f27bf94"
import script from "./WebserverSubComponent.vue?vue&type=script&lang=js"
export * from "./WebserverSubComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__